<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'integrasi-outlet'" :loading="!formReady">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar page-title="Integrasi Outlet" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-x-20 p-t-16" v-if="formReady">
                    <div class="m-d-16">
                        <label class="form-label require m-d-0">
                            Perangkat WA
                        </label>
                        <div class="device-wa d-flex-between-center" @click="gotoSelectDevice">
                            <div>
                                <p class="f-14 f-c-black f-regular m-d-0" v-if="posted.selected">
                                    {{ posted.selected.nama }}
                                </p>
                                <p class="f-14 f-c-midgrey f-regular m-d-0" v-if="posted.selected">
                                    +{{ posted.selected.country_code }}{{ posted.selected.number }}
                                </p>
                            </div>
                            <div>
                                <IconBased width="14" height="8">
                                    <template v-slot:icons>
                                        <NextDown148 />
                                    </template>
                                </IconBased>
                            </div>
                        </div>
                        <ErrorMessage class="error" label="Outlet" :validation="$v.posted.selected" />
                    </div>
                    <div class="m-d-16">
                        <label class="form-label require m-d-0">
                            Outlet
                        </label>
                        <div class="device-wa d-flex-between-center" @click="gotoSelectOutlet">
                            <div>
                                <p class="f-14 f-c-black f-regular m-d-0" v-if="posted.outlet">
                                    {{ posted.outlet.nama }}
                                </p>
                                <p class="f-14 f-regular m-d-0" style="color: #6f728759;" v-else>Pilih outlet...</p>
                            </div>
                            <div>
                                <IconBased width="14" height="8">
                                    <template v-slot:icons>
                                        <NextDown148 />
                                    </template>
                                </IconBased>
                            </div>
                        </div>
                        <ErrorMessage class="error" label="Outlet" :validation="$v.posted.outlet" />
                        <div class="v-error" v-if="notAvailable">Outlet sudah digunakan di perangkat WA lain</div>
                    </div>

                    <div style="margin-top: 35vh;">
                        <SOButton
                            :primary="true"
                            :full="true"
                            :text="'Integrasikan outlet'"
                            :id="`integrasikan-outlet`"
                            :loading="isFetching"
                            :disable="posted.selected === null || posted.outlet === null"
                            @action="saveSetting"
                        />
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import ErrorMessage from "@/component-items/ErrorMessage";
import SOButton from "@/so-components/global/ui/SOButton";

import IconBased from "../../components/iconPack/IconBased.vue";
import NextDown148 from "../../components/iconPack/NextDown14_8.vue";

import { required } from "vuelidate/lib/validators";

import { moduleName } from "../../store/state";

export default {
    name: "IntegrasiOutlet",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        ErrorMessage,
        SOButton,
        IconBased,
        NextDown148,
    },
    data() {
        return {
            formReady: false,
            notAvailable: false,
            posted: {
                selected: null,
                outlet: null,
            },
        };
    },
    mounted() {
        this.init();
        this.smartTrackingView('add_outlet_integrasi_whatsapp')
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.formReady = true;
                this.setIntegrasiOutlet({ type: "iddevice", data: this.getDeviceId });
            }
        },
        formReady: function(newStat, oldStat) {
            if (newStat !== oldStat && newStat) {
                this.posted.selected = this.selectedDevice;
            }
        },
        selectedDevice: function(newVal, oldVal) {
            if (oldVal && newVal.iddevice !== oldVal.iddevice) {
                this.posted.selected = newVal;
            }
        },
        selectedOutlet: function(newVal, oldVal) {
            this.posted.outlet = newVal;
            this.notAvailable = false;
        },
    },
    validations: {
        posted: {
            selected: {
                required,
            },
            outlet: {
                required,
            },
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            listDeviceTiny: "listDeviceTiny",
            listOutletFree: "listOutletFree",
            integrasiOulet: "integrasiOulet",
            response: "response",
            isFetching: "isFetching",
        }),
        getDeviceId() {
            return this.$route.params.id_device;
        },
        getOutletId() {
            return this.integrasiOulet.idoutlet ? this.integrasiOulet.idoutlet : "";
        },
        selectedDevice() {
            return this.listDeviceTiny.find((dc) => {
                return dc.iddevice === this.integrasiOulet.iddevice;
            });
        },
        selectedOutlet() {
            return this.listOutletFree.find((outlet) => {
                return outlet.idoutlet === this.getOutletId;
            });
        },
    },
    methods: {
        ...mapActions({
            integrasiOutlet: `${moduleName}/integrasiOutlet`,
            getListDeviceTiny: `${moduleName}/getListDeviceTiny`,
            setIntegrasiOutlet: `${moduleName}/setIntegrasiOutlet`,
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
        }),
        back() {
            this.$router.push({ name: "wa_autosender.detail_perangkat.daftar_oulet" });
        },
        init() {
            this.getListDeviceTiny();
        },
        gotoSelectDevice() {
            this.$router.push({ name: "wa_autosender.detail_perangkat.daftar_oulet.pilih_perangkat" });
        },
        gotoSelectOutlet() {
            this.$router.push({ name: "wa_autosender.detail_perangkat.daftar_oulet.pilih_outlet" });
        },
        isValid() {
            let { selected, outlet } = this.$v.posted;
            selected.$touch();
            outlet.$touch();

            return selected.$invalid || outlet.$invalid;
        },
        saveSetting() {
            this.smartTrackingClick('simpan_outlet_integrasi_whatsapp')

            if (this.isValid()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            this.integrasiOutlet(this.integrasiOulet)
                .then((res) => {
                    if (!res.data) {
                        this.notAvailable = true;
                        this.$toast.error(res);
                    }
                    let { code, data, status, msg } = res.data;
                    if (code === 200 && status) {
                        this.$router.push({
                            name: "wa_autosender.detail_perangkat.daftar_oulet.set_draft",
                            params: { id_device: data.iddevice, id_outlet: data.idoutlet },
                        });
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.setResponse(resulter.errorResult(msg));
                });
        },
    },
};
</script>
<style scoped>
.device-wa {
    padding: 10px 16px;
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 4px;
}
.v-error {
    color: red;
    font-size: 14px;
    margin-top: 4px;
}
</style>
